"use strict";

var _httpCore = _interopRequireDefault(require("../httpCore"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * 获取子表数据
 */
// 获取表数据


_httpCore.default.createApi('getSubTable', {
  url: '/api/100/table/RetrieveRelTableByHostRecord'
});